import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import { reaction, observable } from "mobx";
import DataWrapper from '../../principal/containers/DataWrapper';
import {Row, Col, FormGroup, Label, Input} from 'reactstrap';
import {TabelaCadastro} from "../components/TabelaCadastro";
import MotivoGeralStore from "../stores/MotivoGeralStore";
import Select from "react-select";
import {escopoEnum, getEscopoById} from "../../../utils/enums";
import {createSelectOptions} from "../../../utils/formatar";
import {Validacao} from "../../comum/components/Validacao";

@inject("store")
@DataWrapper
@observer
export class CadastroMotivoGeral extends Component {
    constructor(props) {
        super(props);
        this.modal                      = this.props.store.modalStore;
        this.appStore                   = this.props.store.appStore;
        this.tituloPaginaStore          = this.props.store.tituloPaginaStore;
        /* Selecionar Controller */
        this.controller                 = new MotivoGeralStore(this.modal);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Motivo geral");

        this.controller.carregarLista();

        this.escopoOptions = createSelectOptions(escopoEnum, "id", "valor");
    }

    /* modais (body e botões) */
    modalForm = () => {
        return(
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Escopo <sup>*</sup></Label>
                        <Select simpleValue  options={this.escopoOptions} value={this.controller.itemSelecionado.escopo}
                                onChange={(value) => this.controller.setEscopo(value)} multi={false} placeholder="Selecione..." noResultsText="Nenhum resultado encontrado" />
                        <Validacao id="escopo" valor={this.controller.itemSelecionado.escopo} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
                <Col xs={12} md={12} lg={12}>
                    <FormGroup>
                        <Label>Nome <sup>*</sup></Label>
                        <Input type="text" maxLength={64} value={this.controller.itemSelecionado.nome} onChange={(event) => this.controller.setNome(event.target.value)} />
                        <Validacao id="nome" valor={this.controller.itemSelecionado.nome} tipo={["isRequired"]} />
                    </FormGroup>
                </Col>
            </Row>
        )
    };

    obterTituloMobile = (objeto) => {
        return objeto.nome;
    };

    obterConteudoMobile = (objeto) => {
        return (
            <div>
                { "Escopo: " + getEscopoById(objeto.escopo).valor}<br/>
            </div>
        )
    };

    escopoFormat(cell) {
        return getEscopoById(cell).valor
    }

    render() {
        /* Colunas da TabelaStore */
        const colunas = [
            {
                field: "escopo",
                label: "Escopo",
                dataFormat: this.escopoFormat
            },{
                field: "nome",
                label: "Nome"
            }
        ];

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel panel-sm" : "panel-sm"}>
                        <TabelaCadastro
                            nomeCadastro={'Motivo geral'}
                            onChange={(value) => this.controller.setLista(value)}
                            listaItens={this.controller.motivoGeralLista}
                            colunas={colunas}
                            temBusca={true}
                            criarNovos={true}
                            modalEditar={this.modalForm()}
                            modalCadastrar={this.modalForm()}
                            preencherModal={(row) => this.controller.preencherModal(row)}
                            editar={() => this.controller.editar()}
                            cadastrar={() => this.controller.cadastrar()}
                            remover={() => this.controller.remover()}
                            tituloMobile={(row) => this.obterTituloMobile(row)}
                            conteudoMobile={(row) => this.obterConteudoMobile(row)}
                            loading={this.controller.loading}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

